import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedVacationBonusDocument,
  RemoveVacationBonusMutation,
  RemoveVacationBonusMutationVariables,
  RemoveVacationBonusDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for removing a vacation bonus and handling the necessary cache updates.
 * @returns {Object} - Contains the removeVacationBonusMutation function, loading state, and error state.
 */
export default function useRemoveVacationBonusMutationHook(): {
  removeVacationBonusMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeVacationBonusMutation, { loading, error }] = useMutation<RemoveVacationBonusMutation, RemoveVacationBonusMutationVariables>(
    RemoveVacationBonusDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedVacationBonus");

        toast(CustomToastComponent, {
          toastId: "vacation-bonus-removed-success",
          data: {
            title: t("toasts.vacationbonusremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedVacationBonusDocument,
          variables: {
            first: 10,
            currentPage: 0,
            after: null,
            filters: {
              activeFrom: null,
              bonusAbsolute: null,
              bonusRelative: null,
              provinces: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeVacationBonusMutation,
    loading,
    error,
  };
}
